import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OhayoUtilModule } from '@ohayojp.com/util';
import { SGContainerComponent } from './sg-container.component';
import { SGComponent } from './sg.component';

const COMPONENTS = [SGContainerComponent, SGComponent];

@NgModule({
  imports: [CommonModule, OhayoUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class SGModule { }
